import React from "react";
import { t } from "i18next";

const tabClass = (isActive) =>
    `px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap
    ${isActive ? "bg-[#147F26] text-white" : "text-gray-500 hover:text-gray-700 hover:bg-gray-100"}`;

export default function individualTabs(activeTabV, setActiveTabV) {
    return <>
        <button className={tabClass(activeTabV === "personal")} onClick={() => setActiveTabV("personal")}>
            {t('personalData')}
        </button>
        <button className={tabClass(activeTabV === "address")} onClick={() => setActiveTabV("address")}>
            {t('addresses')}
        </button>
    </>;
}
